import React from 'react';
import {
  createStyles,
  Grid,
  makeStyles,
  Theme,
  Modal
} from '@material-ui/core';
import {
  ModalCancelButton,
  ModalDeleteButton
} from './parts/cloudStorage/style/style';

type Tprops = {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  title: string;
  list?: string[];
  onDelete: () => void;
};

/**
 * 削除モーダル
 */
export const DeleteModal: React.FC<Tprops> = (props: Tprops) => {
  const { open, setOpen, title, list, onDelete } = props;

  const classes = useStyles();

  return (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby='simple-modal-title'
      aria-describedby='simple-modal-description'
      className={classes.modal}
    >
      <Grid container justify={'center'} className={classes.subpaper}>
        <Grid item xs={12} className={classes.container}>
          <div style={{ textAlign: 'center' }}>
            <h1 style={{ marginBottom: 24, fontSize: 24 }}>{title}を削除</h1>
            <p style={{ color: 'red' }}>選択した{title}を削除しますか？</p>
          </div>
        </Grid>

        {list && (
          <div className={classes.body}>
            <div className={classes.bodyListArea}>
              {list.length > 0 &&
                list.map(item => <p style={{ color: 'red' }}>{item}</p>)}
            </div>
          </div>
        )}

        <Grid item xs={12} className={classes.modalFooter}>
          <ModalCancelButton
            variant='contained'
            onClick={() => {
              setOpen(false);
            }}
          >
            キャンセル
          </ModalCancelButton>
          <ModalDeleteButton
            variant='contained'
            onClick={async () => {
              await onDelete();
              setOpen(false);
            }}
          >
            削除する
          </ModalDeleteButton>
        </Grid>
      </Grid>
    </Modal>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    container: {
      // モーダルを中央に
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderBottom: '1px solid #cfcfcf',
      marginTop: 24
    },
    subpaper: {
      // モーダル内部
      backgroundColor: theme.palette.background.paper,
      borderRadius: theme.spacing(2),
      boxShadow: theme.shadows[5],
      width: '50%'
    },
    header: {
      backgroundColor: theme.palette.background.paper,
      padding: theme.spacing(2, 4, 3),
      borderRadius: theme.spacing(2, 2, 0, 0)
    },
    headerTitle: {
      fontSize: 30,
      marginTop: 10,
      marginBottom: 10
    },
    headerText: {
      fontSize: 20,
      marginTop: 10,
      marginBottom: 10
    },
    body: {
      backgroundColor: theme.palette.background.paper
    },
    bodyListArea: {
      maxHeight: '300px',
      width: '100%',
      marginTop: 24
    },

    modalFooter: {
      // モーダル下部
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderTop: '1px solid #cfcfcf',
      padding: 30
    }
  })
);
